import { ThemeProvider } from '@mui/material';
import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AppComponent } from './components';
import { theme } from './theme';

function App() {
  const { t } = useTranslation()
  React.useEffect(() => {
    document.title = t('title.formInProgress')
  }, []);
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path=":language" element={<AppComponent />} />
          <Route path="*" element={<Navigate to={`/${i18next.languages[0]}`} replace />} />
        </Routes>
      </ThemeProvider>
    </div>
  );
}

export default App;
